export const stripParagraphs = (content) => {
    if (!content) {
        return '';
    }

    return content.replace(/<p>(.*)<\/p>/g, '$1');
}